import type { CSSProperties } from 'react'

import type { Swatch } from '../model/colors'

/** Стиль с пользовательскими CSS-переменными: ключи `--имя` проверяются типом, приведение `as CSSProperties` не нужно. */
export type CssVarStyle = CSSProperties & Record<`--${string}`, string>

/** Переменные цвета блока с именем кассира: правило `.sch-swatch` берёт нужную пару под тему оформления. */
export const swatchStyle = (swatch: Swatch): CssVarStyle => ({
  '--sch-bg-light': swatch.background,
  '--sch-fg-light': swatch.foreground,
  '--sch-bg-dark': swatch.darkBackground,
  '--sch-fg-dark': swatch.darkForeground,
})
